import { FC, useRef } from 'react'
import * as styles from 'components/features/pfm/SpendingPage/SpendingPage.styl'
import { MoneyflowPageProps } from 'interfaces/moneyflow'
import MoneyflowCategoriesModuleContainer from 'components/features/pfm/CategoriesModule/MoneyflowCategoriesModuleContainer'
import MoneyflowBreakdownModuleContainer from 'components/features/pfm/MoneyflowBreakdown/MoneyflowBreakdownModuleContainer'
import TransactionsModuleContainer from 'components/features/pfm/TransactionsModule/TransactionsModuleContainer'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import Anchor from 'components/atoms/navigation/Anchor'
import PageFooterButton from 'components/atoms/buttons/PageFooterButton'
import TrendRankContainer from 'components/features/pfm/TrendRank/TrendRankContainer'
import { DEFAULT_TRANSACTIONS_SORTING, EMPTY_PIE_CHART_LABEL } from 'constants/moneyflow'
import { createSeeAllCategoriesButton, useShouldShowPageParamsStickyHeader } from 'helpers/pageHelpers'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { PageParamsStickyHeader } from 'components/features/pfm/PageParamsHeader/PageParamsStickyHeader'
import { DesktopInternalStickyHeader } from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader'
import { PageParamsHeader } from 'components/features/pfm/PageParamsHeader/PageParamsHeader'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { EditTrackerButton } from 'components/features/pfm/EditTrackerButton/EditTrackerButton'

const SpendingPage: FC<MoneyflowPageProps> = (props) => {
  const {
    timeframe,
    categoryId,
  } = props

  const pageBody = (
    <>
      <div className={ styles.topButtonWrapper }>
        <EditTrackerButton type='spending' categoryId={ categoryId } timeframe={ timeframe } />
      </div>

      <TrendRankContainer type='spending' timeframe={ timeframe } categoryId={ categoryId } />

      <div className={ styles.buttonWrapper }>
        <EditTrackerButton type='spending' categoryId={ categoryId } timeframe={ timeframe } />
      </div>

      <ModuleWrapper
        title='Spending Categories'
        anchor='spending_categories'
        action={ createSeeAllCategoriesButton('spending_categories') }
      >
        <MoneyflowCategoriesModuleContainer
          type='spending'
          timeframe={ timeframe }
          piePlaceholderLabel={ EMPTY_PIE_CHART_LABEL }
        />
      </ModuleWrapper>

      <ModuleWrapper
        title='Breakdown by Category'
        anchor='spending_breakdown'
        card={ false }
        action={ createSeeAllCategoriesButton('spending_breakdown') }
      >
        <MoneyflowBreakdownModuleContainer type='spending' timeframe={ timeframe } categoryId={ categoryId } />
      </ModuleWrapper>

      <ModuleWrapper
        title='Transactions'
        card={ false }
        anchor='spending_details'
        action={ createSeeAllCategoriesButton('spending_details') }
      >
        <TransactionsModuleContainer type='spending' defaultSorting={ DEFAULT_TRANSACTIONS_SORTING } />
      </ModuleWrapper>

      <PageFooterButton text='See Your Income' to='income' />
    </>
  )

  const staticHeaderRef = useRef<HTMLDivElement>(null)
  const shouldShowStickyHeader = useShouldShowPageParamsStickyHeader(staticHeaderRef)

  const notifications = (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='spending_general'
      isPositionRelative
    />
  )

  return (
    <InternalLayoutContainer
      sidebar={ <InternalSidebarContainer /> }
      notifications={ notifications }
      stickyHeader={ <PageParamsStickyHeader type='spending' /> }
      shouldShowStickyHeader={ shouldShowStickyHeader }
    >
      <Anchor placement='spending'>
        <Anchor placement='spending_general'>
          <DesktopInternalStickyHeader isShown={ shouldShowStickyHeader }>
            <PageParamsStickyHeader type='spending' />
          </DesktopInternalStickyHeader>
          <SingleColumnLayout
            header={ <PageParamsHeader type='spending' nodeRef={ staticHeaderRef } /> }
          >
            { pageBody }
          </SingleColumnLayout>
        </Anchor>
      </Anchor>
    </InternalLayoutContainer>
  )
}

export default SpendingPage
